import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Stack, Typography } from "@mui/material";
import {
  FormUnderwritingHomeOptions,
  getUnderwritingQuestions,
  UnderwritingQuestionsForm,
} from "@covertree/new-business-forms";
import { SubmitButton } from "@covertree/ui";
import { useUwContext } from "./useUwContext";
import { UwContext } from "./types";

interface HomeConditionsPropsNotInD2C {
  isD2C: false;
  context: UwContext;
  title?: string;
  hideSubmit?: boolean;
}

interface HomeConditionsPropsInD2C {
  isD2C: true;
}

type HomeConditionsProps =
  | HomeConditionsPropsInD2C
  | HomeConditionsPropsNotInD2C;

function HomeConditions({ isD2C, ...props }: HomeConditionsProps) {
  const form = useFormContext<UnderwritingQuestionsForm>();

  const { state, questions, isFormSubmitting, setModalCondition } = isD2C
    ? useUwContext()
    : (props as HomeConditionsPropsNotInD2C).context;
  const { title, hideSubmit } = props as Partial<HomeConditionsPropsNotInD2C>;

  const conditionsOptions = useMemo(
    () => getUnderwritingQuestions(form, questions, "condition", state),
    [form, form.formState.isValid, questions, state]
  );

  return (
    <Stack spacing={4}>
      {isD2C && (
        <Typography variant="h6" sx={{ py: 1 }}>
          Carefully review each item and confirm all that apply to you.
        </Typography>
      )}
      <FormUnderwritingHomeOptions
        title={
          !isD2C
            ? title ?? "Do these apply for the applicant's home?"
            : undefined
        }
        questions={conditionsOptions}
        setModalCondition={setModalCondition}
      />
      {!hideSubmit && (
        <SubmitButton width={100} loading={isFormSubmitting}>
          Next
        </SubmitButton>
      )}
    </Stack>
  );
}

export { HomeConditions };
